import { entityRegistry } from '@app/icare/entities/registry'
import { createQueryStore, QueryBaseSchema } from '@pkg/api/query'
import { EntityIndexPage } from '@pkg/ui/layout/EntityIndexPage'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/kostentrager/')({
  component: RouteComponent,
})

const queryStore = createQueryStore({
  schema: entityRegistry.costCarrier.search.filterSchema ?? QueryBaseSchema,
})

function RouteComponent() {
  return <EntityIndexPage queryStore={queryStore} entityName="costCarrier" />
}
